import React, {useState,useContext }from 'react'
import { useNavigate } from 'react-router-dom';
import AdminServices from '../../services/AdminServices';
import { AdminContext } from '../../AdminContext';
import { ThemeToggle } from '../../components/ThemeToggle';

function AdminLogin({ setIsAuthenticated, setRole }) {
  const { login } = useContext(AdminContext);
  const [mobileOrEmail, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log(mobileOrEmail, password)
    
    let data;
    try {
      data = await AdminServices.login({mobileOrEmail: mobileOrEmail, password: password});
    } catch (err) {
      // Failed request (wrong credentials, too many attempts, server down): show it on the form
      // instead of an uncaught error.
      const status = err?.response?.status;
      setError(status === 429
        ? "*Too many login attempts. Please wait a few minutes and try again."
        : status === 400 || status === 401 || status === 404
          ? "*Invalid Credentials"
          : `*${err?.response?.data?.message || "Login failed. Please try again."}`);
      return;
    }
    console.log(data)
   if (data?.status === true) {
    const adminData = data?.data?.admin;
    const authToken = data?.data?.accessToken;

    login(adminData?.name, authToken);
      localStorage.setItem('token', authToken);
      localStorage.setItem('refreshToken', data?.data?.refreshToken);
      localStorage.setItem('userRole', adminData?.role);
      localStorage.setItem('admin', adminData?.name);
      localStorage.setItem('image', adminData?.image || '');
      navigate('/admin/dashboard');
   }else{
    setError("*Invalid Credentials");
   }
  };

  return (
   
 
 <div className="login-section position-relative">
        <div className="position-absolute end-0 top-0 z-[5] p-3">
          <ThemeToggle />
        </div>
        <div className="login-section-inner">
          <div className="row">
            <div className="col-md-6 pe-0">
              <div className="login-section-left">
                <h1>Login</h1>
                <p>See your growth and get consulting support!</p>
                <form className="user-login" >
                <div className="input-field mb-3">
                  <label htmlFor="userEmail" className="form-label">Email</label>
                  <input
                    type="email"
                    className="form-control"
                    id="userEmail"
                    placeholder="example@example.com"
                    value={mobileOrEmail}
                    onChange={(e) => setEmail(e.target.value)}
                  />

                </div>
                <div className="input-field mb-3">
                  <label htmlFor="password" className="form-label">Password</label>
                  <input
                    type="password"
                    className="form-control"
                    id="password"
                    placeholder="••••••••••"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                </div>
                <h6 style={{ color: 'red' }}>{error}</h6>
                <div className="input-field mb-3">
                  <input
                    onClick={handleSubmit}
                    type="submit"
                    className="form-control"
                    id="login-btn"
                    value="Login"
                  />
                </div>
              </form>
              </div>
            </div>
            <div className="col-md-6 ps-0">
              <div className="login-section-right">
                <div className="logo-field"> 
                  <img src="img/logo.svg" />
                </div>
                <div className="light-field px-4"> 
                  <img src="img/cuate.svg" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>


  )
}

export default AdminLogin